import React from "react";
import { LANGUAGE } from "../../constants/scriptConfig";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../store/Subtitle/subTitleSlice";
import { useSelector } from "react-redux";

const LanguagePopover = () => {
  const dispatch = useDispatch();
  const { language = "" } = useSelector((state) => state.subTitle);
  const onLanguageSelect = (language) => {
    dispatch(setLanguage(language.target.value));
  };
  return (
    <div className="w-full">
      <div className="flex items-center pl-[25px]  h-[56px] font-medium bg-gradient-sidebar">
        Language
      </div>
      <div className="pt-[19px] pl-[23px] flex flex-col justify-between h-[calc(100%_-_85px)]">
        <div>
          <h1 className="font-bold">Select subtitle language</h1>
          <select
            className="p-2 rounded mt-2 border w-fit"
            defaultValue={`${language}`}
            onChange={onLanguageSelect}
          >
            {LANGUAGE.map((language) => (
              <option key={language} value={language.code}>
                {language.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default LanguagePopover;
